export default __webpack_public_path__ + "static/media/greenArrowUpFull.b15ee074.svg";